<template>
  <!-- <div class="bg_meaning"> -->

  <div>
    <v-container>
      <v-layout v-resize="onResize"></v-layout>
      <v-card class="pa-8 pl-10">
        <v-row>
          <v-col class="pa-0" cols="6">
            <v-card
              :class="font_resize ? 'pa-6 py-2 mt-3' : 'pa-12 mt-3'"
              color="rgba(227, 236, 238, 0.9)"
              style="opacity: 0.8; "
              min-height="550px"
              max-height="650px"
            >
              <h1 class="primary--text" :style="font_resize ? 'font-size:22px' : ''">
                วิสัญญีวิทยา
                <v-btn
                  class="pa-0 mb-2"
                  color="#636262"
                  text
                  fab
                  @click="openSetting()"
                  v-if="mode"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </h1>
              <!-- <pre>{{all_meaning[0].media_path!=''?env+'/'+all_meaning[0].media_path:''}}</pre> -->
              <v-card-text>
                <span
                  class="title_meaning"
                  :style="font_resize ? 'font-size:16px;white-space: pre-wrap;' : 'white-space: pre-wrap;'"
                  v-for="(item, index) in all_meaning"
                  :key="index"
                  v-show="index == 0"
                  v-html="item.anesthesia_description!=''?showString(item.anesthesia_description,445):''"
                ></span>
              </v-card-text>
              <!-- <pre>{{}}</pre> -->
              <span
                v-show="all_meaning!=''?all_meaning[0].anesthesia_description.length>445:false"
                style="font-size:16px; text-decoration:underline;"
                @click="openDialog()"
                type="button"
              >อ่านเพิ่มเติม</span>

              <!-- dialog -->
              <v-dialog v-model="dialog" width="900px">
                <v-card>
                  <v-card-title style="background-color:rgba(227, 236, 238, 0.9);">
                    <h1 class="primary--text" style="'font-size:22px' : ''">วิสัญญีวิทยา</h1>
                    <v-spacer></v-spacer>
                    <v-btn icon class="float-right" @click="close()">
                      <v-icon>mdi-window-close</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-text>
                    <template>
                      <p
                        class="title_meaning pa-10"
                        style="white-space: pre-wrap;"
                        v-for="(item, index) in all_meaning"
                        :key="index"
                        v-if="index == 0"
                        v-html="item.anesthesia_description!=''?item.anesthesia_description:''"
                      ></p>
                    </template>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-card>
          </v-col>
          <v-col cols="6">
            <!-- <v-img class="bg_meaning" src="../../assets/image/meaninglast.jpg"></v-img> -->
            <v-img
              class="bg_meaning"
              v-for="(item, index) in all_meaning"
              v-if="index == 0"
              :key="index"
              :src="item.media_path != '' ? env + '/' + item.media_path : ''"
            ></v-img>
          </v-col>
        </v-row>

        <DialogMeaning ref="dialog_meaning_setting" @getmeaning="getMeaning()"></DialogMeaning>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import DialogMeaning from "../Settings/DialogMeaning";
export default {
  components: {
    DialogMeaning,
  },
  data: () => ({
    mode: false,
    length: 5,
    window: 0,
    font_resize: false,
    env: process.env.VUE_APP_API,
    // meaning_content:
    //   "คือ แพทย์ผู้เชี่ยวชาญการให้ยาชาและยาสลบ โดยมักทำงานร่วมกับแพทย์ผ่าตัดเพื่อระงับความรู้สึกเจ็บปวดของคนไข้ก่อนทำการผ่าตัดเพียงชั่วคราว ผู้ที่จะเป็นวิสัญญีแพทย์ได้ต้องจบการศึกษาแพทยศาสตร์บัณฑิตก่อนแล้วจึงจะมาต่อเฉพาะทางสาขาวิสัญญีวิทยาใช้เวลาศึกษาประมาณ 3 ปี ส่วนพยาบาลก็สามารถเรียนรู้ฝึกทักษะเกี่ยวกับวิสัญญีวิทยาได้โดยการฝึกเป็นวิสัญญีวิทยาใช้เวลาในการศึกษาประมาณ 1 ปี และทำงานภายในการควบคุมดูแลของวิสัญญีแพทย์",
    all_meaning: [],
    dialog: false,
  }),
  created() {
    this.mode = this.$session.get("token")
      ? this.$session.get("permission") == "admin"
      : false;
    this.getMeaning();
  },
  methods: {
    openSetting() {
      this.$refs.dialog_meaning_setting.openSetting();
    },
    onResize() {
      if (window.innerWidth <= 1270) this.font_resize = true;
      else this.font_resize = false;
    },
    getMeaning() {
      let meaning = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/anesthesia")
        .then((response) => {
          // console.log(response.data);
          meaning = response.data;
          this.all_meaning = meaning;
        });
    },
    lenght_data(data) {
      const max_lenght = 445;
      let data_string = "";
      for (let index = 0; index < max_lenght; index++) {
        data_string += data[index];
      }
      data_string += "...";
      return data_string;
    },
    openDialog() {
      this.dialog = true;
    },
    close() {
      // setTimeout(() => {
      //   this.$refs.form.resetValidation();
      // }, 100);
      this.dialog = false;
    },
    showString(str, length) {
      // parameter invalid
      if (!str) return "";
      if (!length) return str;
      // parameter is validate
      if (str.length > length) return str.substring(0, length) + " . . .";
      else return str;
    },
  },
};
</script>
